var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDragAndDropIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "dragAndDropIcon_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M24 45V17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25l8-8 8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 33h7a8 8 0 000-16h0a15.026 15.026 0 00-30 .3A7.927 7.927 0 002 25a8.024 8.024 0 008 8h7"
  }))));
}

export default SvgDragAndDropIcon;